import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash'
import { useCallback, useEffect } from "react";
import * as SetupActions from "../redux/actions/SetupAction"
import {ErrorToast, SuccessToast} from '../redux/actions/ToasterAction';
import {ShowSpinner, HideSpinner} from '../redux/actions/SpinnerAction';
import { useHierarchyService } from "./useHierarchyService";

const useSetup = ({refreshTree = true})=>{ 
    
    const { actions:{GetMultipleLocationTreeWithFilter, RefreshTree, SetSelectedTreeNodeByKey}} = useHierarchyService();

    const selectedLocations = useSelector((state)=>{
        return state.setup.selectedLocations
    })
   
    
    const dispatchSetup = useDispatch();
    
    const SetSelectedLocations = useCallback((selectedLocations)=>{
        var action = SetupActions.SetSelectedLocations(selectedLocations)
        dispatchSetup(action)
    }, [dispatchSetup])


    const AddNode = useCallback(async (node, data) => {
        try{
            if (!_.isEmpty(node) && !_.isEmpty(data)) {
                dispatchSetup(ShowSpinner());
                var action = await SetupActions.AddTreeNode(node, data);
                dispatchSetup(action)
                dispatchSetup(HideSpinner());
                dispatchSetup(SuccessToast('Success', 'Saved Successfully!'));
                await RefreshTree();
            }
        }
        catch(err) {
            dispatchSetup(HideSpinner());
            dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message')));
          }

    }, [dispatchSetup, RefreshTree])
   
    const EditNode = useCallback(async (node, data) => {
        if (!_.isEmpty(node) && !_.isEmpty(data)) {
            try {
            dispatchSetup(ShowSpinner());
            var action = await SetupActions.EditTreeNode(node, data);
            dispatchSetup(action);
            dispatchSetup(HideSpinner());
            dispatchSetup(SuccessToast('Success', 'Updated Successfully!'));
            await RefreshTree();
        }
        catch(err) {
            dispatchSetup(HideSpinner());
            dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message')));
          }
        }

    }, [dispatchSetup, RefreshTree])

    const DeleteNode = useCallback(async(node)=>{
        if (!_.isEmpty(node)) {           
            dispatchSetup(ShowSpinner());          
            try {
                var action = await SetupActions.DeleteTreeNode(node);
                dispatchSetup(action);
                dispatchSetup(HideSpinner());
                dispatchSetup(SuccessToast('Success', 'Deleted Successfully!'));               
                SetSelectedTreeNodeByKey(node.parentId);
                await RefreshTree();
              }
              catch(err) {
                dispatchSetup(HideSpinner());
                dispatchSetup(ErrorToast('Error', _.get(err, 'response.data.message')));
              }
        }

    }, [dispatchSetup, RefreshTree, SetSelectedTreeNodeByKey])

    const DuplicateNode = useCallback(async (node, data, locationId) => {
        if (!_.isEmpty(node) && !_.isEmpty(data)) {
            dispatchSetup(ShowSpinner());
            var action = await SetupActions.DuplicateTreeNode(node, data, locationId);
            dispatchSetup(action)
            dispatchSetup(HideSpinner());
            dispatchSetup(SuccessToast('Success', 'Saved Successfully!'));
            await RefreshTree();
        }

    }, [dispatchSetup, RefreshTree])

    useEffect(()=>{ 
        if(refreshTree && selectedLocations &&  _.get(selectedLocations, "length")){      
            GetMultipleLocationTreeWithFilter({locationIds:selectedLocations.map((l)=>l.id)});
        }
    }, [GetMultipleLocationTreeWithFilter, selectedLocations, refreshTree])
    
    return {data: {selectedLocations}, actions: {SetSelectedLocations, AddNode, EditNode, DeleteNode, DuplicateNode}};

}

export default useSetup;